/**
 * TanStack Query hook for the live-sessions tile. Polls every 30s — mirrors
 * the REFETCH_INTERVAL convention the other "who's active right now" admin
 * queues use (features/admin/ooc/hooks.ts, feedback/hooks.ts,
 * product-review/hooks.ts): this screen exists to show what's happening
 * RIGHT NOW, so a stale read defeats its purpose.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import {
  getLiveSessions,
  type LiveSessionsOrderBy,
  type LiveSessionsResponse,
} from "@/features/admin/live-sessions/api";

const REFETCH_INTERVAL = 30_000;

export const liveSessionsKeys = {
  list: (orderBy: LiveSessionsOrderBy) => ["admin", "live-sessions", orderBy] as const,
} as const;

export function useLiveSessions(
  orderBy: LiveSessionsOrderBy,
): UseQueryResult<LiveSessionsResponse, Error> {
  return useQuery<LiveSessionsResponse, Error>({
    queryKey: liveSessionsKeys.list(orderBy),
    queryFn: () => getLiveSessions(orderBy),
    refetchInterval: REFETCH_INTERVAL,
  });
}
